import { render, staticRenderFns } from "./_vertify.vue?vue&type=template&id=4fac924e"
import script from "./_vertify.vue?vue&type=script&lang=js"
export * from "./_vertify.vue?vue&type=script&lang=js"
import style0 from "./_vertify.vue?vue&type=style&index=0&id=4fac924e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports